import React from "react";
import Input from "../form/Input";
import Collapse from "../common/Collapse";

import Fa from "../common/Fa";

const form = [
  {
    label: "Latitud",
    attr: "lat",
    desc: "Coordenada que corresponde a la Latitud. Ejemplo: -25.126764."
  },
  {
    label: "Longitud",
    attr: "lon",
    desc: "Coordenada que corresponde a la Longitud. Ejemplo: -57.749567."
  }
];

/**
 * Se encarga de construir un panel que contiene los criterios
 * de filtrado para cuentas corrientes y padrones.
 */
export default class LonLat extends React.Component {
  /**
   * Almacena del estado del componente
   */
  state = {
    loading: false,
    expanded: false,
    lon: -57.0,
    lat: -25.0
  };
  /**
   * Referencia al modal
   */
  modal = React.createRef();

  /**
   * Cuando se renderiza el componete se setea la referencia al
   * componente.
   */
  componentDidMount() {
    this.props.onRef(this);
    this.initComponent();
  }

  /**
   * Se encarga de inicializar el componete, recupera los parametros de
   * la URL y verifica los mismos, corresponde a la modalidad embedible.
   */
  initComponent() {
    const { expanded } = this.props;
    this.setState({
      expanded: expanded
    });
  }

  searchReady(search) {
    //this.setState({ loading: search });
  }

  /**
   * Se encarga de mostrar el dialgo.
   */
  open = data => {
    this.modal.toggle();
    this.setState({
      expanded: true
    });
  };

  /**
   * Se encarga de manejar el close del dialog.
   */
  close = () => {
    this.setState({
      expanded: false
    });
    this.modal.toggle();
  };

  /**
   * Se encarga de manejar el change de los componetes del formulario
   * @param {*} name nombre del atributo
   * @param {*} val valor
   */
  onChange(name, val) {
    this.setState({ [name]: val });
  }

  /**
   * Valida que el formulario sea válido
   */
  validate() {
    return this.state.lon && this.state.lat;
  }

  /**
   * Este método se encarga de disparar la busqueda de las parcelas.
   */
  buscar = () => {
    if (this.validate()) {
      //this.setState({ loading: true });
      this.props.onSearch(this.state);
      this.close();
    }
  };

  /**
   * Se encarga de renderizar el fomulario de busqueda que corresponde
   * al partial aplicable a los campos de cuentas corrientes y padrones.
   */
  renderForm() {
    return (
      <div className="column">
        <div className="columns">
          {form.map((item, index) => {
            let val = this.state[item.attr]
              ? parseInt(this.state[item.attr])
              : undefined;
            return (
              <div key={index} className="column">
                <Input
                  value={this.state[item.attr]}
                  type="number"
                  label={item.label}
                  placeholder={item.label}
                  help={item.desc}
                  onChange={val => this.onChange(item.attr, val)}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  /**
   * Construye el formulario con los filtros de departamento y distritos.
   */
  buildForm() {
    const { urbano, rural } = this.state;
    return (
      <section className="no-padding">
        <p>
          Permite ubicar un marcador y centrar el visor en las coordendas
          especificadas. El sistema de proyecciones tenido en cuenta para la
          busqueda es el <code>EPSG:4326</code>.
        </p>
        <br />
        {this.renderForm()}
        <div className="column">
          <button
            disabled={this.state.loading}
            id="buscar-parcela"
            onClick={evt => this.buscar()}
            className="button is-primary"
          >
            {!this.state.loading && (
              <span>
                <Fa icon="map-marker-alt" />
                Ubicar
              </span>
            )}
            {this.state.loading && (
              <span>
                <Fa icon="compass fa-spin" />
                Buscando...
              </span>
            )}
          </button>
        </div>
      </section>
    );
  }

  /**
   * Se encarga de renderizar el componente.
   */
  render() {
    return (
      <Collapse
        open={this.state.expanded}
        styleName="column is-5 float-panel"
        onRef={ref => (this.modal = ref)}
      >
        {this.state.expanded && (
          <nav className="panel buscador">
            <div className="panel-heading">
              Filtros
              <p className="close" onClick={evt => this.close()}>
                <Fa icon="times-circle" />
              </p>
            </div>
            <div className="panel-block">{this.buildForm()}</div>
          </nav>
        )}
      </Collapse>
    );
  }
}
